import { render, staticRenderFns } from "./resend-document-modal.vue?vue&type=template&id=00a902fd&scoped=true&"
import script from "./resend-document-modal.vue?vue&type=script&lang=js&"
export * from "./resend-document-modal.vue?vue&type=script&lang=js&"
import style0 from "./resend-document-modal.vue?vue&type=style&index=0&id=00a902fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a902fd",
  null
  
)

component.options.__file = "resend-document-modal.vue"
export default component.exports